
import {defineComponent} from "vue";

const __default__ = defineComponent({
  name: "SectionDivisor",
  props: {
    title: {
      type: String,
    },
    colorLabel: {
      type: String,
    },
    colorBackground: {
      type: String,
    },
    colorLine: {
      type: String,
    },
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "6373e31d": (_ctx.colorBackground),
  "2750b7a5": (_ctx.colorLabel),
  "2a8f1d23": (_ctx.colorLine)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__